import type { Special } from '@/types';

export const specials: Special[] = [
  {
    id: '1',
    title: '阶层寓言：从《寄生虫》到《燃烧》',
    subtitle: '当韩国电影开始解剖贫富',
    intro: '当韩国电影不再满足于讲述个体命运，而是把镜头对准整座社会的金字塔，一批作品以寓言的方式撕开了繁荣表象下的裂缝。本期专题沿着《寄生虫》《燃烧》《国家破产之日》的线索，梳理韩国导演笔下的阶层图景。',
    cover: 'https://readdy.ai/api/search-image?query=conceptual%20editorial%20image%20about%20social%20class%2C%20stacked%20abstract%20geometric%20blocks%20in%20olive%20and%20amber%2C%20deep%20navy%20background%2C%20minimalist%20artsy%20composition%2C%20no%20text&width=1200&height=750&seq=kfilm-special-01&orientation=landscape',
    movieIds: ['1', '4', '29'],
    articleIds: ['r1-1', 'r1-2', 'r4-1'],
  },
  {
    id: '2',
    title: '复仇美学：朴赞郁的三部曲',
    subtitle: '暴力也可以是一种形式',
    intro: '朴赞郁用华丽的视听语言，把复仇这一古老母题重新打磨成一件艺术品。从《老男孩》到《亲切的金子》，复仇不再只是情绪，而是一场关于伦理、罪罚与观看的精密实验。',
    cover: 'https://readdy.ai/api/search-image?query=conceptual%20editorial%20image%20about%20revenge%20aesthetics%2C%20abstract%20shattered%20mirror%20shards%20in%20crimson%20and%20charcoal%2C%20dark%20moody%20composition%2C%20minimalist%2C%20no%20text&width=1200&height=750&seq=kfilm-special-02&orientation=landscape',
    movieIds: ['2', '7', '27'],
    articleIds: ['r2-1', 'r2-2', 'r7-1'],
  },
  {
    id: '3',
    title: '现实主义：李沧东的人间',
    subtitle: '在苦难里寻找诗意',
    intro: '李沧东的镜头总是贴近最普通的人。他不提供答案，只是让观众与角色一起承受、一起追问。本期专题聚焦《诗》《密阳》《绿洲》，看一位导演如何用克制书写人间。',
    cover: 'https://readdy.ai/api/search-image?query=conceptual%20editorial%20image%20about%20realism%2C%20soft%20faded%20ivory%20paper%20texture%20with%20delicate%20flower%20shadow%2C%20warm%20muted%20beige%20and%20amber%2C%20minimalist%2C%20no%20text&width=1200&height=750&seq=kfilm-special-03&orientation=landscape',
    movieIds: ['5', '8', '26'],
    articleIds: ['r5-1', 'r8-1', 'r26-1'],
  },
  {
    id: '4',
    title: '类型拼贴：奉俊昊的作者电影',
    subtitle: '用商业类型写社会寓言',
    intro: '奉俊昊最独特的地方，在于他能在怪兽片、悬疑片、科幻片里塞进最锋利的现实批评。《汉江怪物》《杀人回忆》《雪国列车》无一不是类型外壳下的深刻寓言。',
    cover: 'https://readdy.ai/api/search-image?query=conceptual%20editorial%20image%20about%20genre%20cinema%2C%20abstract%20film%20strip%20with%20geometric%20shapes%20in%20navy%20and%20amber%2C%20minimalist%20graphic%20composition%2C%20no%20text&width=1200&height=750&seq=kfilm-special-04&orientation=landscape',
    movieIds: ['16', '6', '17'],
    articleIds: ['r16-1', 'r6-1', 'r17-1'],
  },
  {
    id: '5',
    title: '无声与留白：金基德的极简影像',
    subtitle: '当语言退场，影像登场',
    intro: '金基德相信，最好的表达往往不需要台词。《空房间》几乎全无对白，《春夏秋冬又一春》以四季轮回完成叙事。本期专题探讨极简影像中，沉默如何承载最饱满的情感。',
    cover: 'https://readdy.ai/api/search-image?query=conceptual%20editorial%20image%20about%20silence%20and%20space%2C%20minimal%20empty%20room%20with%20single%20light%20beam%2C%20soft%20ivory%20and%20slate%20tones%2C%20zen%20minimalist%20composition%2C%20no%20text&width=1200&height=750&seq=kfilm-special-05&orientation=landscape',
    movieIds: ['10', '9', '13'],
    articleIds: ['r10-1', 'r9-1', 'r13-1'],
  },
];